<div>
	<h2>{{ 'mantenimientoCertificados.title' | translate }}</h2>
	<section class="filters-framed"	*ngIf="filtersVisible">
		<form [formGroup]="filtersForm" [ngClass]="{'show-error': showError}">
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'mantenimientoCertificados.certificateIssuer' | translate}}</label>
                <app-filterable-list [itemsList]="titulares" [selectedItem]="filtersForm.get('titular')" [placeHolder]="false"></app-filterable-list>
            </div>
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
                <label>{{'global.denominacion' | translate}}</label>
                <app-filterable-list [itemsList]="denominaciones" [selectedItem]="filtersForm.get('denominacion')" [placeHolder]="false"></app-filterable-list>
            </div>
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
				<label>{{'global.finca' | translate}}</label>
                <input type="text" formControlName="finca">
            </div>
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
				<label>{{'global.matricula' | translate}}</label>
				<input type="text" formControlName="matricula">
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
				<label>{{'global.estado' | translate}}</label>
				<app-filterable-list [itemsList]="estados" [selectedItem]="filtersForm.get('estado')" [placeHolder]="false"></app-filterable-list>
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'">
				<label>{{'global.certificadoNum' | translate}}</label>
				<input type="text" formControlName="certificadoNum">
			</div>
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.inicio' | translate}}</label>
                <input [matDatepicker]="fechaInicio" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaInicio" (click)="fechaInicio.open()">
                <mat-datepicker #fechaInicio></mat-datepicker>
            </div>
            <div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="calendar">
                <label>{{'global.fecha.fin' | translate}}</label>
                <input [matDatepicker]="fechaFin" placeholder="{{'global.fecha.placeholder' | translate}}" formControlName="fechaFin" (click)="fechaFin.open()">
                <mat-datepicker #fechaFin></mat-datepicker>
            </div>
			<div [ngClass]="this.isSmallScreen ? 'entry-3-small' : 'entry-5'" class="radio-group move-left">
                <input type="radio" id="inicioVigenciaIns" [value]="true" formControlName="dateType">
                <label for="inicioVigenciaIns">{{'global.fecha.inicioVigenciaLong' | translate}}</label>
                <input type="radio" id="finVigenciaIns" [value]="false" formControlName="dateType">
                <label for="finVigenciaIns">{{'global.fecha.finVigenciaLong' | translate}}</label>
            </div>
		</form>
	</section>
	<section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}" (click)="filtersVisible=!filtersVisible"
          title="{{'global.filtros.abrir' | translate}}">
          <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
          (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
          <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
          [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
          title="{{'global.filtros.limpiar' | translate}}">
          <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
          title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
          <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
	</section>

	<section class="export-buttons">
        <i class="fa-solid fa-circle-question" title="{{'global.obtenerAyuda' | translate}}" (click)="openDocHelp()"></i>
    </section>

	<div class="table-wrapper">
		<div class="table-container">
			<table>
				<thead>
					<tr>
						<th class="icon"></th>
						<th class="icon"></th>
						<th class="icon"></th>
						<th class="id sortable nowrap" (click)="toOrderBy('x=> x.id', 2)">
							ID
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.id', 2)"></i>
							</div>
						</th>
						<th class="string centered sortable nowrap" (click)="toOrderBy('x=> x.estadoId', 3)">
							{{ 'global.estado' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.estadoId', 3)"></i>
							</div>
						</th>
						<th class="string sortable nowrap" (click)="toOrderBy('x=> x.nCertificadoExpedicion', 4)">
							{{ 'global.certificadoNum' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.nCertificadoExpedicion', 4)"></i>
							</div>
						</th>
						<th class="string sortable nowrap" (click)="toOrderBy('x=> x.ConsumosCertificadoExpedicion.Select(y => y.Consumo.ConsumosDetalle.SelectMany(z => z.Designacion.Etiquetador)).OrderBy(y => y.Des).FirstOrDefault().Des', 5)">
							{{ 'mantenimientoCertificados.issuer' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.ConsumosCertificadoExpedicion.Select(y => y.Consumo.ConsumosDetalle.SelectMany(z => z.Designacion.Etiquetador)).OrderBy(y => y.Des).FirstOrDefault().Des', 5)"></i>
							</div>
						</th>
						<th class="string sortable nowrap" (click)="toOrderBy('x=> x.ConsumosCertificadoExpedicion.Select(y => y.Consumo.Almacen).OrderBy(y => y.Des).FirstOrDefault().Des', 6)">
							{{ 'global.almacen' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.ConsumosCertificadoExpedicion.Select(y => y.Consumo.Almacen).OrderBy(y => y.Des).FirstOrDefault().Des', 6)"></i>
							</div>
						</th>
						<th class="string">
							{{ 'global.denominacion' | translate }}
						</th>
						<th class="string sortable nowrap" (click)="toOrderBy('x=> x.ConsumosCertificadoExpedicion.Select(y => y.Consumo.Lote).OrderBy(y => y).FirstOrDefault()', 7)">
							{{ 'global.loteLotes' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.ConsumosCertificadoExpedicion.Select(y => y.Consumo.Lote).OrderBy(y => y).FirstOrDefault()', 7)"></i>
							</div>
						</th>
						<th class="string sortable nowrap" (click)="toOrderBy('x=> x.ConsumosCertificadoExpedicion.Sum(y => y.Unidades)', 8)">
							{{ 'global.cajas' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.ConsumosCertificadoExpedicion.Sum(y => y.Unidades)', 8)"></i>
							</div>
						</th>
						<th class="string sortable nowrap" (click)="toOrderBy('x=> x.matricula', 9)">
							{{ 'global.matricula' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.matricula', 9)"></i>
							</div>
						</th>
						<th class="date sortable nowrap" (click)="toOrderBy('x=> x.FechaInicioVigencia', 10)">
							{{ 'global.fecha.inicioVigencia' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.FechaInicioVigencia', 10)"></i>
							</div>
						</th>
						<th class="date sortable nowrap" (click)="toOrderBy('x=> x.FechaFinVigencia', 11)">
							{{ 'global.fecha.finVigencia' | translate }}
							<div class="sortable-icons">
								<i [ngClass]="getIcon('x=> x.FechaFinVigencia', 11)"></i>
							</div>
						</th>
						<th class="multi-actions">

						</th>
					</tr>
				</thead>
				<tbody *ngFor="let certificado of certificados; let i = index; trackBy: trackByCertificadoId">
					<tr (click)="toggleDropdownInfo(i);" [ngClass]="{'dropdownInfo': dropdownInfo === i}">
						<td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'" title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
			            </td>
						<td class="icon">
							<a *ngIf="(certificado && certificado.certificadoExpedicionVechain?.existeRegBlockchain)" target="_blank">
								<i class="fas fa-circle-nodes" title="{{'global.blockchain.verBlockchain' | translate}}" style="cursor: pointer;"></i>
							</a>
						</td>
						<td class="icon">
							<a *ngIf="certificado && certificado.certificadoExpedicionBloqAuto" target="_blank">
								<i class="fa-solid fa-exclamation" [style]="'color: #e61717'" title="{{'global.verError' | translate}}" style="cursor: pointer;" (click)="showAlertModal()" app-click-stop-propagation></i>
							</a>
						</td>
						<td class="id">{{ certificado.id }}</td>
						<td class="icon">
							<i class="far fa-check-circle" [ngStyle]="getCheckIconColor(certificado.estadoId)" [title]="getCheckIconTitle(certificado.estadoId)"></i>
						</td>
						<td class="string">{{ certificado.nCertificadoExpedicion }}</td>
						<td class="string">{{ certificado.desEtiquetador }}</td>
						<td class="string">{{ certificado.desAlmacen }}</td>
						<td class="string">{{ certificado.desDenominacion }}</td>
						<td class="string">{{ certificado.lote }}</td>
						<td class="string">{{ certificado.sumNumCajas }}</td>
						<td class="string">{{ certificado.matricula }}</td>
						<td class="date">{{ certificado.fechaInicioVigencia | date: 'shortDate' : undefined : defaultLanguage }}</td>
						<td class="date">{{ certificado.fechaFinVigencia | date: 'shortDate' : undefined : defaultLanguage }}</td>
						<td class="multi-actions-bigger">
							<i class="fas fa-stream" (click)="showSection(i)" app-click-stop-propagation title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}"></i>
							<!-- Toggle deshabilitado para Etiquetador. Válido: 2, Inválido: 3 -->
                            <i *ngIf="certificado.estadoId === 1 || (certificado.estadoId === 2 && role === 'Etiquetador')" class="fa-solid fa-toggle-on disabled"></i>
                            <i *ngIf="certificado.estadoId === 2 && role !== 'Etiquetador'" class="fa-solid fa-toggle-on" title="{{'mantenimientoCertificados.table.invalidateCertificate' | translate}}" app-click-stop-propagation (click)="updateStatus(certificado.id, 3)"></i>
                            <i *ngIf="certificado.estadoId === 3 && role !== 'Etiquetador'" class="fa-solid fa-toggle-off" title="{{'mantenimientoCertificados.table.validateCertificate' | translate}}" app-click-stop-propagation (click)="updateStatus(certificado.id, 2)"></i>
                            <i *ngIf="certificado.estadoId === 4 || certificado.estadoId === 5 || (certificado.estadoId === 3 && role === 'Etiquetador')" class="fa-solid fa-toggle-off disabled"></i>
							<!-- PDF -->
							<i  class="fas fa-file" [ngClass]="{ 'disabled': certificado.estadoId === 1 }" [title]="'titles.verCertificado' | translate" app-click-stop-propagation (click)="showPdfModal(certificado.id, 'view')"></i>
							<!-- Firma -->
							<i  class="fas fa-pen-nib" [ngClass]="{ 'disabled': (role === 'Auditor' || role === 'Supervisor') || (certificado.estadoId !== 1 || certificado.certificadoExpedicionBloqAuto) }" [title]="'titles.firmarCertificado' | translate" app-click-stop-propagation (click)="showPdfModal(certificado.id, 'sign')"></i>
							<!-- Borrado y cancelación -->
							<i *ngIf="certificado.estadoId === 1"  class="far fa-trash-alt" [ngClass]="{'disabled': role === 'Auditor' || role === 'Supervisor'}" [title]="'titles.eliminar' | translate" app-click-stop-propagation (click)="showDeleteModal(certificado.id)"></i>
							<i *ngIf="certificado.estadoId !== 1" style="width: 16px;" class="fas fa-xmark" [title]="'titles.cancelar' | translate" [ngClass]="{ 'disabled': (role === 'Auditor' || role === 'Supervisor') || !certificado.registroCancelable }"
							app-click-stop-propagation (click)="showCancelModal(certificado.id)" ></i>
						</td>
					</tr>

					<!-- Panel "Más Información" -->
					<tr *ngIf="dropdownInfo === i">
						<td colspan="16">
							<div class="detail">
								<div class="title">{{'global.masInformacion' | translate}}</div>
								<div class="block-inline gap nowrap">
									<label>{{'global.csvLong' | translate}}</label>
									<p>{{ certificado.codigoSeguroVerificacion }}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline">
									<label>{{ 'global.fecha.firma' | translate }}</label>
									<p>{{ certificado.fechaInicioVigencia | date: 'shortDate' : undefined : defaultLanguage }}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline">
									<label>{{ 'global.fecha.insercionShort' | translate }}</label>
									<p>{{ certificado.fechaIns | date: 'shortDate' : undefined : defaultLanguage }}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline">
									<label>{{ 'global.fecha.actualizacionShort' | translate }}</label>
									<p>{{ certificado.fechaUpd | date: 'shortDate' : undefined : defaultLanguage }}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
							</div>
						</td>
					</tr>

					<!-- Panel "Blockchain Información" -->
					<tr *ngIf="dropdownInfo === i && (certificado && certificado.certificadoExpedicionVechain?.existeRegBlockchain)">
						<td colspan="16">
							<div class="detail">
								<div class="title">{{'global.blockchain.informacion.titulo' | translate}}</div>
								<div class="block-inline">
									<label>{{'global.blockchain.informacion.blockchain' | translate}}</label>
									<span>
										{{ certificado.certificadoExpedicionVechain?.blockchain }}
										<a 
											style="color: #A39B4B; text-decoration: none; font-family: 'regular';" 
											[href]="getBlockchainLink(certificado.certificadoExpedicionVechain?.txId)" target="_blank">
												({{'global.blockchain.informacion.enlace' | translate}})</a>
									</span>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline">
									<label>{{'global.blockchain.informacion.fechaRegistro' | translate}}</label>
									<p>{{certificado.certificadoExpedicionVechain?.fechaRegistro | date: 'dd/MM/yyyy HH:mm:ss'}}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline gap nowrap">
									<label>{{'global.blockchain.informacion.input' | translate}}</label>
									<p>{{certificado.certificadoExpedicionVechain?.textoHash}}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline gap nowrap">
									<label>{{'global.blockchain.informacion.idCripto' | translate}}</label>
									<p>{{certificado.certificadoExpedicionVechain?.txId}}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline gap nowrap">
									<label>{{'global.blockchain.informacion.hash' | translate}}</label>
									<p>{{certificado.certificadoExpedicionVechain?.hash}}</p>
								</div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline"><label></label><p></p></div>
								<div class="block-inline"><label></label><p></p></div>
							</div>
						</td>
					</tr>
					
					<tr *ngIf="dropdownSection === i">
						<td colspan="16">
							<section class="tabs">
								<ul>
									<li [ngClass]="{'active': pestanaActiva[i] === 1}" (click)="showExpedition(i)">{{('global.expedicion' | translate)}}</li>
									<li [ngClass]="{'active': pestanaActiva[i] === 2}" (click)="showStatus(i)">{{('global.estadoPlural' | translate)}}</li>
								</ul>
								<content>
									<app-expedicion-certificado [certificadoId]="certificado.id" *ngIf="pestanaActiva[i] === 1"></app-expedicion-certificado>
									<app-estado-certificado [certificadoId]="certificado.id" *ngIf="pestanaActiva[i] === 2"></app-estado-certificado>
								</content>
							</section>
						</td>
					</tr>
				</tbody>
				<tfoot *ngIf="!certificados || (certificados && certificados.length < 1)">
					<tr>
						<td colspan="16">
							{{ 'global.noContent' | translate }}
						</td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
	<app-paginator 
	*ngIf="certificados && certificados.length > 0" [itemsPerPage]="itemsPerPage" [currentPage]="currentPage + 1"
	[totalItems]="totalItems" [visiblePages]="visiblePages" 
	(pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)"></app-paginator>

	<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
</div>

<div class="modal" *ngIf="deleteModal || cancelModal">
    <div class="modal-content">
        <header>
            <h4>{{ deleteModal ? ('global.eliminar.descripcion' | translate) : ('global.cancelarRegistro.descripcion' | translate) }}</h4>
        </header>
        <content>
            <p>{{ deleteModal ? ('global.eliminar.confirmacion' | translate) : ('global.cancelarRegistro.confirmacion' | translate) }}</p>
        </content>
        <footer>
            <button class="secondary" (click)="closeDeleteCancelModal()">{{ 'global.cancelar' | translate }}</button>
            <button (click)="deleteCancelCertificate()">{{ 'global.confirmar' | translate }}</button>
        </footer>
    </div>
</div>

<div class="modal" *ngIf="alertModal">
    <div class="modal-content" style="max-width: 40rem;">
        <header>

        </header>
        <content>
            <p>{{ 'global.error.certificadoBloqueadoParte1' | translate }}</p>
            <p>{{ 'global.error.certificadoBloqueadoParte2' | translate }}</p>
        </content>
        <footer style="justify-content: flex-end;">
            <button (click)="closeAlertModal()">{{ 'global.cerrar' | translate }}</button>
        </footer>
    </div>
</div>

<div class="modal" *ngIf="pdfModal">
	<!-- Evitar doble scroll con overflow-y: hidden -->
    <div class="modal-content" style="width: 99vw; height: 95vh; overflow-y: hidden;">
        <header>
            <h4>{{ pdfMode === 'sign' ? ('titles.firmarCertificado' | translate) : ('titles.verCertificado' | translate) }}</h4>
        </header>
        <content style="height: 100%;">
			<!-- Usar clase "user-select" solo en casos como este (PDF del Certificado), cuando se permita la selección y copia de texto !! -->
            <viewer-pdf class="user-select" [base64PdfModal]="base64Certificado"></viewer-pdf>
        </content>
        <footer style="justify-content: flex-end; gap: 3em;">
            <button class="secondary" (click)="closeSignaturePdfModal()">
				{{ pdfMode === 'sign' ? ('global.cancelar' | translate) : ('global.cerrar' | translate) }}</button>
            <button (click)="signOrDownlowadCertificado()">
				{{ pdfMode === 'sign' ? ('global.firmar' | translate) : ('global.descargar' | translate) }}</button>
        </footer>
    </div>
</div>